import { useState, type FC } from 'react';

import { useStores } from '../../stores/useStores';
import StarIcon from '../SVGIcons/StarIcon/StarIcon';

import CategoryIconImage from './CategoryIconImage';

interface IIconCategory {
  name: string;
  imageUrl?: string;
  scImageUrl?: string;
}

const IconCategory: FC<IIconCategory> = ({ name, imageUrl, scImageUrl }) => {
  const { coinTypeStore } = useStores();
  const isGcCoinType = coinTypeStore.coinType === 'GC';

  const [imageError, setImageError] = useState<boolean>(false);

  if (!imageUrl || imageError) {
    return <StarIcon fill={isGcCoinType ? '#FFC600' : '01DB80'} />;
  }

  if (!scImageUrl) {
    return (
      <CategoryIconImage
        name={name}
        url={imageUrl}
        visible={true}
        onError={() => setImageError((prevState) => !prevState)}
      />
    );
  }

  return (
    <>
      <CategoryIconImage
        name={name}
        url={imageUrl}
        visible={isGcCoinType}
        onError={() => setImageError((prevState) => !prevState)}
      />
      <CategoryIconImage
        name={name}
        url={scImageUrl}
        visible={!isGcCoinType}
        onError={() => setImageError((prevState) => !prevState)}
      />
    </>
  );
};

export default IconCategory;
